import React from 'react';
import { useSolicitacaoAcessoContext } from '../../providers/solicitacaoAcesso';
import { SolicitacaoAcessoModal } from './index';

export function SolicitacaoAcessoModalGlobal() {
  const { isModalOpen, closeModal } = useSolicitacaoAcessoContext();

  return <SolicitacaoAcessoModal isOpen={isModalOpen} onClose={closeModal} />;
}
